import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let bom = new BaseTableModule('/ws/bom_sheet/');

const state = {
    ...bom.state,
    columns: [
        {text: '', value: 'drag', sortable: false, filterable: true, divider: false, brief: true, width: 30},
        // {text: '№', value: 'order_number', sortable: false, filterable: true, divider: false, brief: true, width: 40},
        // {text: '', value: 'user_comment', sortable: false, divider: false, brief: true, width: 30},
        {text: '', value: 'manager', sortable: false, filterable: true, divider: false, brief: true, width: 30},
        {text: '', value: 'task_status', sortable: false, filterable: true, divider: false, brief: true, width: 50},
        {text: 'QTY', value: 'qty', sortable: false, filterable: true, divider: false, brief: true, width:60},
        // {text: 'Original text', value: 'original_text', sortable: false, filterable: true, divider: false, brief: true,},
        // {text: 'Web', value: 'web', sortable: false, filterable: true, divider: false, brief: true, width:60},
        {text: 'EX', value: 'partial_match', sortable: false, filterable: true, divider: false, brief: true, width: 20},
        {text: '', value: 'link', sortable: false, filterable: true, divider: false, brief: true, width: 30},
        {text: 'MPN', value: 'mpn', sortable: false, filterable: true, divider: false, brief: true,},
        // {text: 'Correct status', value: 'correct_status', sortable: false, filterable: true, divider: false, brief: true, width: 120},
        // {text: 'Created by', value: 'created_by', sortable: true, divider: true, brief: true,},
        // {text: 'Created on', value: 'created_on', sortable: true, divider: true, brief: true,},
        // {text: 'Edited by', value: 'edited_by', sortable: true, divider: true, brief: true,},
        // {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, brief: true,},
    ],
    briefView: true,
    options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['order_number'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: true,
    },
};
const getters = {
    ...bom.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true)
        } else {
            return state.columns
        }
    },
};
const actions = {
    ...bom.actions,
};
const mutations = {
    ...bom.mutations,
};

export default {
    modules: {
        BomSheet: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}